module.exports = __webpack_public_path__ + "static/media/badge_laodong.012f512f.svg";